// /tech index (2026-09-04): technicians land on My Day; every other role lands on the first function of its bottom bar
// (dispatcher → Tickets, admin → Dashboard, ...). Waits for the workspace so nobody is bounced to the wrong page.
import { Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useWorkspace } from '@/contexts/WorkspaceContext';
import TechMyDayPage from './TechMyDayPage';

export default function TechHome() {
  const { ws, loading } = useWorkspace();
  if (!ws && loading) {
    return <Box sx={{ display: 'flex', justifyContent: 'center', pt: 8 }}><CircularProgress /></Box>;
  }
  if (!ws) return <TechMyDayPage />;
  const hasMyDay = ws.functions.some((f) => f.key === 'my_day');
  const active = ws.active_role?.name || (ws.roles.length === 1 ? ws.roles[0].name : '');
  if (hasMyDay && (active === 'Technician' || !active)) return <TechMyDayPage />;
  const first = ws.nav.map((k) => ws.functions.find((f) => f.key === k)).find((f) => f && f.key !== 'my_day') || ws.functions.find((f) => f.key !== 'my_day');
  if (first) return <Navigate to={first.path} replace />;
  return <TechMyDayPage />;
}
